export const RESULTS_LOADING = 'results-loading';
export const RESULTS_LOADED = 'results-loaded';
export const SEARCH_RESULTS_LOADED = 'search-results-loaded';
export const SEARCH_RESULTS_EMPTY = 'empty-search-results';
export const FACETS_CHANGED = 'facets-changed';